var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.contextMenu,style:({ left: _vm.mouseX + 'px', top: _vm.mouseY + 'px' })},[_c('div',{class:_vm.$style.link,on:{"click":function($event){return _vm.confirm(0)}}},[_vm._v(" "+_vm._s(_vm.$t('common.confirmAll'))+" ")]),(!_vm.isTargetChecked)?_c('div',{class:_vm.$style.link,on:{"click":function($event){return _vm.confirm(_vm.notificationId)}}},[_vm._v(" "+_vm._s(_vm.$t('common.confirmCurrent'))+" ")]):_vm._e(),(_vm.isTargetEvent)?_c('router-link',{class:_vm.$style.link,attrs:{"to":{
      name: 'computers-computer-log-record',
      params: {
        computer: _vm.userId,
        log: _vm.log.slug,
        record: _vm.eventId,
      },
      query: {
        dateFrom: _vm.eventRange.day.from,
        dateTo: _vm.eventRange.day.to,
      },
    },"target":"_blank"}},[_vm._v(" "+_vm._s(_vm.$t('common.goToHistoryEntry'))+" ")]):_vm._e(),(_vm.isTargetEvent)?_c('router-link',{class:_vm.$style.link,attrs:{"to":{
      name: 'advanced',
      query: {
        dateFrom: _vm.eventRange.window.from,
        dateTo: _vm.eventRange.window.to,
        computer: _vm.userId,
        logId: _vm.logId,
        record: _vm.eventId,
      },
    },"target":"_blank"}},[_vm._v(" "+_vm._s(_vm.$t('common.viewInTheEventStream'))+" ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }